// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ChevronLeft from "@awc/XDL/Icons/ChevronLeft";
import ChevronRight from "@awc/XDL/Icons/ChevronRight";
import Close from "@awc/XDL/Icons/Close";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import { ComponentThemeProps } from "@insite/mobius/globals/baseTheme";
import { css } from "styled-components";

/* stylelint-disable */
const PanelMenuDefaultProps: ComponentThemeProps["panelMenu"]["defaultProps"] = {
    headerColor: "common.ui1",
    bodyColor: "common.ui1",
    childTypographyProps: {
        size: fontConfig.fontSize.regular,
        lineHeight: fontConfig.lineHeight.singleLineRegular,
        css: css`
            display: block;
            word-wrap: break-word;
            width: 100%;
        `,
    },
    backIconProps: {
        src: ChevronLeft,
        size: 15,
        css: css`
            &&& {
                color: ${color("common.ui1")};
            }
            &,svg {
                width: 8px;
            }
        `,
    },
    closeIconProps: {
        src: Close,
        size: 15,
        css: css`
            &&& {
                color: ${color("common.ui1")};
            }
        `,
    },
    panelRowProps: {
        color: "common.ui1",
        moreIconProps: {
            src: ChevronRight,
            size: 14,
            css: css`
                color: ${color("common.ui1")};
                height: 20px;
                justify-content: flex-end;
                &,
                svg {
                    width: auto;
                }
            `,
        },
    },
};
/* stylelint-enable */

export default PanelMenuDefaultProps;
